import { eventNames } from 'constants/eventNames';

import React, { useRef } from 'react';

import { Text } from '@thinkific/chalk/Text';

import { NodeViewWrapper } from '@tiptap/react';

import * as css from './Mention.css';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function MentionNodeView({ node }: { node: any }) {
  const { id, label } = node.attrs;
  const mentionRef = useRef<HTMLButtonElement>(null);

  return (
    <NodeViewWrapper as="span" className="relative group">
      <Text
        as="span"
        className={css.mention}
        color="action.primary.dark"
        dataQa={`mention-node-${id}`}
        variant="body.md"
        onClick={() => {
          PubSub.publish(eventNames.OPEN_PROFILE_PANEL, {
            userId: id,
            lastElementRef: mentionRef,
          });
        }}
      >
        @{label}
      </Text>
    </NodeViewWrapper>
  );
}
